import { createFileRoute } from "@tanstack/react-router";

import { SignInPage } from "../../../features/auth/SignInPage";
import { signInSearchOf } from "../../../features/auth/signInSearch";

export const Route = createFileRoute("/_public/sign-in/email")({
  validateSearch: signInSearchOf,
  component: SignInPage,
});
